import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Chart, ArcElement, Tooltip, Legend, type ChartOptions, type Plugin } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

Chart.register(ArcElement, Tooltip, Legend);

interface DonutChartProps {
  values?: number[];
  label?: string[];
//   [key: string]: any;
}
const DonutChart: React.FC<DonutChartProps> = ({ values, label }) => {

  const labels = label || ['0–15 days', '16–30 days', '31–45 days', '>45 days'];
  const DataValues = values || [15, 26.9, 20, 38.1];
  const total = DataValues.reduce((s, v) => s + v, 0);

  const data = {
    labels,
    datasets: [
      {
        data: DataValues,
        backgroundColor: ['#6E7280', '#9FA6B8', '#CFD4E0', '#E8EBF5'],
        hoverOffset: 8,
        borderWidth: 0,
      },
    ],
  };

  const centerPlugin: Plugin<'doughnut'> = {
    id: 'centerPlugin',
    beforeDraw: (chart) => {
      const ctx = chart.ctx;
      const area = chart.chartArea;
      if (!area) return;
      ctx.save();
      ctx.restore();
    },
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.label ?? '';
            const val = Number(context.raw ?? 0);
            const percent = total > 0 ? (val / total) * 100 : 0;
            return `${percent.toFixed(1)}%\n(${label})`;
          },
        },
      },
    },
  }; 

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
    
      <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
        <Box display="flex" alignItems="center" gap={4}>
          {labels.map((lbl, i) => (
            <Box key={lbl} display="flex" alignItems="center" gap={1}>
              <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: data.datasets[0].backgroundColor[i] }} />
              <Typography variant="body2" sx={{ color: '#6B6B6B' }}>{lbl}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ width: '100%', height: { xs: 480, md: 640 }, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

        {/* small centered subtitle above the donut (light gray) */}
        <Box display="flex" justifyContent="center" sx={{ mb: 3, width: '100%' }}> 
          <Typography variant="caption" sx={{ color: '#9E9E9E' }}>Patient Wait Time (in days)</Typography>
        </Box>

        {/* center the chart canvas; use maxWidth so it stays centered and responsive */}
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: { xs: '72%', md: '48%' }, maxWidth: 720, height: { xs: 360, md: 480 } }}>
            <Doughnut data={data} options={options} plugins={[centerPlugin]} />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default DonutChart;
